import React from "react";
import { functions } from "../../../../../firebase";
import { httpsCallable } from "firebase/functions";
import { Button } from "../../../../../design/button";

const DropboxButton: React.FC = () => {
  const onPress = async () => {
    const { data } = await httpsCallable(
      functions,
      "getDropboxAuthUrl",
    )({
      redirectUri: window.location.origin + "/callback/dropbox",
    });
    window.location.replace((data as { url: string }).url);
  };
  return <Button onClick={onPress}>Connect</Button>;
};

export default DropboxButton;
